import { schema } from 'normalizr';

const entitySchema = new schema.Entity('news', undefined, { idAttribute: 'id' });

export default entitySchema;
